import { FC, PropsWithChildren } from 'react'

import { SxProps, TableCell, Theme, useTheme } from '@mui/material'

export const HORIZONTAL_TABLE_HEADER_CELL_TEST_ID = 'horizontal-table-header-cell' as const

type Props = PropsWithChildren & { sx?: SxProps<Theme> }

export const HeaderCell: FC<Props> = ({ sx, children }) => {
  const theme = useTheme()

  return (
    <TableCell
      data-testid={HORIZONTAL_TABLE_HEADER_CELL_TEST_ID}
      sx={{
        minWidth: 150,
        position: 'sticky',
        left: 0,
        top: 0,
        backgroundColor: theme.palette.horizontalTable.border.color,
        ...sx
      }}
    >
      {children}
    </TableCell>
  )
}
